import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { afterPoints, beforePoints } from '../data/coachSystem';
export function TransformationSection() {
  return <section className="border-y border-char-line bg-ink py-11 sm:py-14" aria-labelledby="transformation-title" data-id="element-138" data-mp="31uw5grvc94zh">
      <div className="mx-auto w-full max-w-[42rem] px-4 sm:px-6 lg:max-w-5xl" data-id="element-139" data-mp="2rz2kql7gu56m">
        <span className="mx-auto mb-5 block h-[2px] w-8 rounded-full bg-orange" aria-hidden="true" data-id="element-140" data-mp="2nwz6xpxbqoi6" />
        <h2 id="transformation-title" className="text-center font-display text-[1.8rem] font-semibold uppercase leading-[1.1] tracking-tight text-ivory sm:text-[2.3rem]" data-id="element-141" data-mp="2j5zasmw14agq">
          From scattered coaching ideas to one complete system.
        </h2>

        <div className="mt-7 grid gap-3 sm:grid-cols-2 sm:gap-5" data-id="element-142" data-mp="248qa32ku5ucc">
          <div className="rounded-xl border border-char-line bg-char p-5 shadow-card" data-id="element-143" data-mp="24b2q3a719umr">
            <h3 className="font-display text-[0.72rem] font-semibold uppercase text-ivory-dim" style={{
            letterSpacing: '0.24em'
          }} data-id="element-144" data-mp="2086ew4jtp0su">
              Before
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-145" data-mp="k3votwbxv5qs">
              {beforePoints.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-146" data-mp="5atj7hbj9nsz">
                  <XIcon className="mt-0.5 h-4 w-4 shrink-0 text-ivory-dim" aria-hidden="true" data-id="element-147" data-mp="acr92uefvguw" />
                  <span className="text-[0.9rem] leading-snug text-ivory-muted" data-id="element-148" data-mp="130n6y2fqvet9">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>

          <div className="rounded-xl border border-orange/30 bg-char-light p-5 shadow-lift" data-id="element-149" data-mp="t27bjn9opjdy">
            <h3 className="font-display text-[0.72rem] font-semibold uppercase text-orange" style={{
            letterSpacing: '0.24em'
          }} data-id="element-150" data-mp="39r4h571in0ad">
              With Basketball Coach System™
            </h3>
            <ul className="mt-4 space-y-2.5" data-id="element-151" data-mp="1ka8wlbp18kin">
              {afterPoints.map(item => <li key={item} className="flex items-start gap-2.5" data-id="element-152" data-mp="1fami6yxgwy89">
                  <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-orange" aria-hidden="true" data-id="element-153" data-mp="1ak64retndclw" />
                  <span className="text-[0.9rem] font-medium leading-snug text-ivory" data-id="element-154" data-mp="15kbb53ihm8x5">
                    {item}
                  </span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}